@if (formGroup) {
  <form [formGroup]="formGroup" (ngSubmit)="save()">
    <dialog class="bm-modal" open (document:keydown.escape)="closeModal.emit()">
      <div class="bm-modal-box max-h-[80vh] overflow-y-auto">
        <h4 class="text-lg font-bold mb-2">Status erstellen</h4>
        <fieldset class="bm-fieldset px-0">
          <div class="grid grid-cols-2 gap-2">
            <div class="flex flex-col gap-1">
              <label class="bm-fieldset-label" for="status-main-category"> Hauptkategorie </label>
              <input
                id="status-main-category"
                type="number"
                min="0"
                step="1"
                class="bm-input"
                placeholder="z. B. 3"
                formControlName="main_category"
              />
            </div>
            <div class="flex flex-col gap-1">
              <label class="bm-fieldset-label" for="status-sub-category"> Unterkategorie </label>
              <input
                id="status-sub-category"
                type="number"
                min="0"
                step="1"
                class="bm-input"
                placeholder="z. B. 0"
                formControlName="sub_category"
              />
            </div>
          </div>
          @if (formGroup.hasError("categoriesIncomplete")) {
            <p class="text-error text-xs">Haupt- und Unterkategorie bitte gemeinsam angeben oder beide leer lassen.</p>
          }

          <label class="bm-fieldset-label" for="status-name"> Bezeichnung* </label>
          <input id="status-name" class="bm-input" placeholder="z. B. erledigt" formControlName="name" />
          <p class="text-xs text-base-content/60">Anzeige: {{ previewLabel() }}</p>

          <label class="bm-fieldset-label"> Standardaufgaben </label>
          <select class="bm-select" formControlName="task_ids">
            <option [value]="null">Bitte wählen...</option>
            @for (task of project.tasks; track task) {
              <option [value]="task.id">
                {{ task.name }}
              </option>
            }
          </select>
          <label>Wählen Sie eine oder mehrere Aufgaben aus...</label>

          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="unplanned" />Ticket ungeplant
          </label>

          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="closed" />Ticket geschlossen
          </label>

          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="canceled" />Ticket storniert
          </label>

          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="report_closed" />Arbeitsbericht kann von
            Technikern nicht geändert werden
          </label>

          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="fixer_forbidden" />Ticketfixer deaktiviert
          </label>

          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="visible_app" />Sichtbar in App
          </label>

          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="fallback_status" />Fallback-Status (Ziel beim
            Zurücksetzen)
          </label>

          <label class="bm-fieldset-label"> Farbe </label>
          <input type="color" class="bm-input" formControlName="color" />

          <label class="bm-fieldset-label"> Mailtemplate </label>
          <select class="bm-select" formControlName="mail_template_id">
            <option [value]="null">Bitte wählen...</option>
            @for (mail_template of project.mail_templates; track mail_template) {
              <option [value]="mail_template.id">
                {{ mail_template.subject }}
              </option>
            }
          </select>

          <label class="bm-fieldset-label"> E-Mail </label>
          <input class="bm-input" formControlName="email" />
        </fieldset>

        <div class="bm-modal-action">
          <button class="bm-btn bm-btn-secondary" type="button" (click)="closeModal.emit()">Abbrechen</button>
          <button class="bm-btn bm-btn-primary" type="submit" [disabled]="!formGroup.valid">Speichern</button>
        </div>
      </div>
    </dialog>
  </form>
}
